// dấu phép tính
export default {
  add: 1,
  subtract: -1,
  multiple: 2,
  divide: 3,
};
